<template>
  <v-dialog max-width="800" v-model="dialog" scrollable persistent>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        {{ title }}
        <v-spacer />
        <v-btn dark icon>
          <v-icon @click="closePopup">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <FormStudent ref="form-student" v-if="mode === 'student'" />
        <FormClass ref="form-class" v-else />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn color="gray" class="ma-2 px-8" :disabled="excelIsCreated" @click="closePopup" outlined>Hủy</v-btn>
        <v-spacer />
        <v-btn color="primary" class="elevation-0 px-8" :loading="excelIsCreated" @click="onDownload"
          >Xác nhận và tải</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// lib
import { mapGetters } from 'vuex'
// compo
import FormStudent from './FormStudent.vue'
import FormClass from './FormClass.vue'
// utils
import formStudentService from './frmStdUtils'
import formClassService from './frmClsUtils'
// main
export default {
  components: { FormStudent, FormClass },
  data() {
    return { dialog: false, mode: '', excelIsCreated: false }
  },
  computed: {
    ...mapGetters('app', ['currentSchoolYear']),
    title() {
      if (this.mode === 'student') return 'Xuất excel điểm toàn bộ môn học theo học sinh'
      return 'Xuất excel điểm toàn bộ môn học theo lớp'
    }
  },
  methods: {
    openPopup(mode = '') {
      this.mode = mode
      this.dialog = true
    },
    closePopup() {
      this.reset()
      this.dialog = false
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    alertInvalidForm() {
      return this.$alert.error('Vui lòng chọn đầy đủ các trường thông tin yêu cầu')
    },

    async onDownloadStudent() {
      const formRef = this.$refs['form-student']
      const isValid = formRef.validate()
      if (!isValid) return this.alertInvalidForm()
      this.$loading.active = true
      const { semester, classData } = formRef.getData()
      if (!semester || !classData) return this.alertInvalidForm()
      await formStudentService.exec({
        semester,
        classData,
        currentSchoolYear: this.currentSchoolYear
      })
      this.$loading.active = false
      this.$alert.success('Tải file thành công')
    },
    async onDownloadClass() {
      const formRef = this.$refs['form-class']
      const isValid = formRef.validate()
      if (!isValid) return this.alertInvalidForm()
      this.$loading.active = true
      const { semesterData, classData, factorData } = formRef.getData()
      if (!semesterData || !classData || !factorData) return this.alertInvalidForm()

      await formClassService.exec({
        semesterData,
        classData,
        currentSchoolYear: this.currentSchoolYear,
        factorData
      })
      this.$loading.active = false
      this.$alert.success('Tải file thành công')
    },

    async onDownload() {
      if (this.mode === 'student') {
        await this.onDownloadStudent()
      } else {
        await this.onDownloadClass()
      }
    }
  }
}
</script>
